import React from "react";
import { Link } from "react-router-dom";
import {
	Coffee,
	ShoppingCart,
	History,
	Wallet,
	LayoutDashboard,
} from "lucide-react";

export default function POSDashboard() {
	const menuItems = [
		{
			title: "Nouvelle vente",
			description: "Accéder à la caisse tactile",
			icon: ShoppingCart,
			path: "/pos/checkout",
		},
		{
			title: "Historique des ventes",
			description: "Consulter les transactions POS",
			icon: History,
			path: "/pos/sales",
		},
		{
			title: "Clôture de caisse",
			description: "Gérer la fermeture de caisse",
			icon: Wallet,
			path: "/pos/closing",
		},
	];

	return (
		<div className="min-h-screen bg-[#F7F3ED]">
			<header className="bg-[#34251D] px-6 py-6 text-white">
				<div className="mx-auto flex max-w-7xl items-center gap-3">
					<Coffee size={30} />
					<div>
						<h1 className="text-2xl font-bold">Léger's Coffee</h1>
						<p className="text-sm text-white/70">Système de caisse — POS</p>
					</div>
				</div>
			</header>

			<main className="mx-auto max-w-7xl px-6 py-10">
				<div className="mb-8 flex items-center gap-3">
					<LayoutDashboard size={28} />
					<div>
						<h2 className="text-2xl font-bold">Tableau de bord</h2>
						<p className="text-gray-500">Gestion de votre point de vente</p>
					</div>
				</div>

				<div className="grid gap-5 md:grid-cols-3">
					{menuItems.map((item) => {
						const Icon = item.icon;

						return (
							<Link
								key={item.path}
								to={item.path}
								className="rounded-2xl border border-[#E6E1D6] bg-white p-6 shadow-sm transition hover:shadow-md"
							>
								<div className="mb-5 flex h-14 w-14 items-center justify-center rounded-xl bg-[#F7F3ED]">
									<Icon size={27} />
								</div>

								<h3 className="mb-2 text-lg font-semibold">{item.title}</h3>

								<p className="text-sm text-gray-500">{item.description}</p>
							</Link>
						);
					})}
				</div>

				<div className="mt-10 rounded-2xl border border-amber-200 bg-amber-50 p-5">
					<p className="font-semibold text-amber-900">Mode préparation</p>
					<p className="mt-1 text-sm text-amber-800">
						Les paiements physiques ne sont pas encore activés. Le POS est
						actuellement en cours de configuration.
					</p>
				</div>
			</main>
		</div>
	);
}
